import { novels, comics } from "@/mocks/homeData";

export default function NovelComicSection() {
  return (
    <section id="novels" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-label tracking-[0.2em] text-primary-600 uppercase">
            Reading
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            免费小说与漫画，排版舒适随时翻
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            小说按题材分类，连载与完结一目了然；漫画采用竖屏条漫样式，逐话连贯翻页。
            长时间阅读也不累眼，进度可在本设备上继续。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="lg:col-span-3">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                <i className="ri-book-2-line text-accent-600 mr-2" aria-hidden="true"></i>
                字幕免费小说推荐
              </h3>
              <span className="text-xs text-foreground-500 whitespace-nowrap">共 {novels.length} 本</span>
            </div>

            <div className="mt-4 flex flex-col gap-3">
              {novels.map((n, idx) => (
                <article
                  key={n.id}
                  className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300"
                >
                  <span className="w-8 h-8 shrink-0 rounded-md bg-accent-100 text-accent-700 font-heading font-bold flex items-center justify-center text-sm">
                    {idx + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <h4 className="font-heading text-base font-bold text-foreground-950">{n.title}</h4>
                      <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[11px] whitespace-nowrap">
                        {n.genre}
                      </span>
                      <span className="px-2 py-0.5 rounded bg-background-200 text-foreground-700 text-[11px] whitespace-nowrap">
                        {n.status}
                      </span>
                    </div>
                    <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{n.intro}</p>
                    <div className="mt-2.5 flex items-center gap-4 text-[11px] text-foreground-500">
                      <span>
                        <i className="ri-user-line mr-1" aria-hidden="true"></i>
                        {n.author}
                      </span>
                      <span>
                        <i className="ri-fire-line mr-1" aria-hidden="true"></i>
                        {n.heat} 热度
                      </span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                <i className="ri-image-2-line text-secondary-600 mr-2" aria-hidden="true"></i>
                漫画免费看
              </h3>
              <span className="text-xs text-foreground-500 whitespace-nowrap">共 {comics.length} 部</span>
            </div>

            <div className="mt-4 grid grid-cols-2 gap-3 md:gap-4">
              {comics.map((c) => (
                <article
                  key={c.id}
                  className="group rounded-lg overflow-hidden bg-background-50 border border-background-200 transition-colors hover:border-secondary-300"
                >
                  <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
                    <img
                      src={c.cover}
                      alt={`${c.title} 漫画封面`}
                      title={`${c.title} 中文在线漫画免费看`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-secondary-500 text-background-50 text-[10px] whitespace-nowrap">
                      {c.genre}
                    </span>
                  </div>
                  <div className="p-3">
                    <h4 className="font-heading text-sm font-bold text-foreground-950 truncate">{c.title}</h4>
                    <p className="mt-1 text-[11px] text-foreground-500">{c.update}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}